import {
  Badge,
  Box,
  Button,
  Chip,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  Tooltip,
  Typography,
} from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import { Modal } from '../../../components';
import ActionsList from '../../../components/ActionsList';
import LoadingComponent from '../../../components/Loading';
import { CYAN_COLOR, MORADO_COLOR } from '../../../constants/ColorsConst';
import * as CONST from '../../../constants/FieldsConst';
import { dateformat } from '../../../helpers';
import { useNotification } from '../../../helpers/notification';
import { textLabelsTable } from '../../invitados/components/ListadoInvitados';
import { NameComponent } from '../../usuarios/components/ListadoUsuarios';
import {
  deleteTiposUsuariosAction,
  getAllTiposUsuariosAction,
  saveTiposUsuariosAction,
  setActivoTiposUsuariosAction,
} from '../TiposUsuariosAction';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import DashboardIcon from '@mui/icons-material/Dashboard';

const ListadoTiposUsuarios = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { addNotification } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const tiposUsuariosStore = Redux.useSelector((state) => state.tiposUsuarios);

  const [rows, setRows] = React.useState([]);
  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [isDelete, setIsDelete] = React.useState(false);
  const [isToggleActive, setIsToggleActive] = React.useState(false);

  React.useEffect(() => {
    if (tiposUsuariosStore.all && tiposUsuariosStore.all.length === 0) {
      getAllTiposUsuariosAction(dispatch, entidadesStore.activo.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const fetchData = () => {
      const rows = [];
      tiposUsuariosStore.all.forEach((el) => {
        rows.push({
          ...el,
          [CONST.DATE]: dateformat(el.date, {}),
          active: el.active ? 'Activo' : 'Bloqueado',
          actions: el,
        });
      });
      setRows(rows);
    };
    fetchData();
  }, [tiposUsuariosStore.all]);

  const _handleEditClick = async (id) => {
    const data = tiposUsuariosStore.all.find((el) => el.id === id);
    await setActivoTiposUsuariosAction(dispatch, data);
    setOpenModalForm(true);
  };

  const _handleDeleteClick = async (id) => {
    setLoadingDelete(true);
    await deleteTiposUsuariosAction(
      { dispatch, addNotification },
      id,
      entidadesStore.activo.id
    );
    setIsDelete(false);
    setLoadingDelete(false);
  };

  const _handleToggleActiveClick = async (id) => {
    setLoadingDelete(true);
    await saveTiposUsuariosAction(
      { dispatch, addNotification },
      entidadesStore.activo.id,
      id,
      {
        active: !tiposUsuariosStore.activo.active,
      }
    );
    setIsToggleActive(false);
    setLoadingDelete(false);
  };

  const getIsRequired = (code) => {
    return ['admin', 'owner', 'client', 'security', 'teacher', 'client'].includes(code);
  }

  const columns = [
    {

      name: CONST.ID,
      options: {
        display: 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.NAME,
      label: 'Nombre',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const data = tiposUsuariosStore.all.find((el) => el.id === tableMeta.rowData[0]);
          if (!data) return null;
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {data.name || data.userType?.name} {getIsRequired(data.userType?.code) && <span style={{color: 'red'}}>*</span>}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.ACTIVE,
      label: 'Estatus',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                sx={{
                  backgroundColor:
                    value === 'Activo' ? CYAN_COLOR : MORADO_COLOR,
                  color: 'white',
                }}
              />
            </Tooltip>
          );
        },
      },
    },
    
    {
      name: 'platforms',
      label: 'Plataforma',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const data = tiposUsuariosStore.all.find((el) => el.id === tableMeta.rowData[0]);
          if (!data) return null;
          return (
            
            data.userType.platforms[0] === 'APP' ? 
            (<Chip icon={<SmartphoneIcon />} label="APP" variant="outlined" />) :
            (<Chip icon={<DashboardIcon />} label="PANEL" variant="outlined" />)

          );


        },
      },
    },
    {
      name: CONST.ACTIONS,
      label: 'Acción',
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const data = tiposUsuariosStore.all.find((el) => el.id === tableMeta.rowData[0]);
          if (!data) return null;
          return (
            <Box align="left" sx={{ width: '5em' }}>
              <ActionsList
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={!['app', 'panel'].includes(value.userType.code) ? undefined : async () => {
                  await setActivoTiposUsuariosAction(dispatch, value);
                  setIsDelete(true);
                }}
                onToggleActive={['admin', 'owner', 'client'].includes(value.userType.code) ? undefined : async () => {
                  await setActivoTiposUsuariosAction(dispatch, value);
                  setIsToggleActive(true);
                }}
                active={value.active}
              />
            </Box>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    onSearchChange: (text) => {
      console.log('buscardor', text);
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    textLabels: textLabelsTable,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
    selectableRowsHideCheckboxes: true,
  };

  return (
    <Grid container>
      <LoadingComponent
        isLoading={tiposUsuariosStore.loadingGetAll || loadingDelete}
        text="Cargando lista..."
      />
      <Grid item md={12}>
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {tiposUsuariosStore.activo && (
        <Modal
          id="modalFormTiposUsuarios"
          title="Eliminar"
          open={isDelete}
          maxWidth="sm"
          onClose={() => setIsDelete(!isDelete)}
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              ¿Seguro que quieres eliminar este tipo de invitación?
              <p>
                <strong>{tiposUsuariosStore.activo.name}</strong>
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="error"
              variant="outlined"
              onClick={async () => {
                await _handleDeleteClick(tiposUsuariosStore.activo.id);
              }}
            >
              ELIMINAR
            </Button>
            <Button
              sx={{ color: MORADO_COLOR }}
              onClick={() => setIsDelete(false)}
            >
              CANCELAR
            </Button>
          </DialogActions>
        </Modal>
      )}

      {tiposUsuariosStore.activo && (
        <Modal
          id="modalToggleActivo"
          title={`${
            tiposUsuariosStore.activo.active ? 'Bloquear' : 'Activar'
          } ${tiposUsuariosStore.activo.name}`}
          open={isToggleActive}
          maxWidth="sm"
          onClose={() => setIsToggleActive(!isToggleActive)}
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {`¿Seguro que quieres ${
                tiposUsuariosStore.activo.active ? 'Bloquear' : 'Activar'
              } este tipo de invitación?`}
              <p>
                <strong>{tiposUsuariosStore.activo.name}</strong>
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="error"
              variant="outlined"
              onClick={async () => {
                await _handleToggleActiveClick(tiposUsuariosStore.activo.id);
              }}
            >
              ACEPTAR
            </Button>
            <Button
              sx={{ color: MORADO_COLOR }}
              onClick={() => setIsToggleActive(false)}
            >
              CANCELAR
            </Button>
          </DialogActions>
        </Modal>
      )}
    </Grid>
  );
};

export default ListadoTiposUsuarios;
